import { render, staticRenderFns } from "./AppPagesUpdateForm.vue?vue&type=template&id=5cd649a0"
import script from "./AppPagesUpdateForm.vue?vue&type=script&lang=js"
export * from "./AppPagesUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports